import React from 'react'

import { useRouter } from 'next/router'

import PhatButton from 'components/formElements/PhatButton'
import Icon from 'components/elements/Icon'

import styles from './filteredViewMessage.module.scss'


const FilteredViewMessage = () => {
  const router = useRouter()

  const removeFilterQuery = () => {
    const { pathname, query } = router
    delete router.query.filter
    router.replace({pathname, query}, undefined, {shallow: true})
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.message}>
            <Icon name="search" />
            <span>
              This deck is currently being filtered, click here to remove the filter and view the full deck.
            </span>
          </div>

          <PhatButton onClick={removeFilterQuery}>Remove filter</PhatButton>
        </div>
      </div>
    </>
  )
}

export default FilteredViewMessage
